import {
  transformCompanyDetails,
  transformContactDetails,
  transformMessages,
  transformPersonalDetails,
} from './common.mapper';

import {
  ApiBusinessCard,
  ApiBusinessCardInformation,
  BusinessCard,
  BusinessCardInformation,
} from '../interfaces/business-card.interface';

export function transformBusinessCardInformation(
  apiBusinessCardInformation: ApiBusinessCardInformation
): BusinessCardInformation {
  return {
    uuid: apiBusinessCardInformation.uuid,
    user_uuid: apiBusinessCardInformation.user_uuid,
    modified_at: apiBusinessCardInformation.modified_at,
  };
}

export function transformBusinessCard(apiBusinessCard: ApiBusinessCard): BusinessCard {
  return {
    ...transformBusinessCardInformation(apiBusinessCard),
    ...transformPersonalDetails(apiBusinessCard.personal_details),
    ...transformCompanyDetails(apiBusinessCard.company_details),
    ...transformContactDetails(apiBusinessCard.contact_details),
    ...transformMessages(apiBusinessCard.messages),
  };
}
